import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import qs from "qs";
import jwt_decode from "jwt-decode";
import router from '../router'


Vue.use(Vuex);

export default new Vuex.Store({


  state: {
    snackbarToken: false,
    snackbarMessage: null,
    snackbarTimeout: null,
    outboundADDRESS: null,
    // urlApi: this._vm.$VUE_APP_URL_API,
    // urlApiAuthen: this._vm.$VUE_APP_URL_API_AUTHEN,
    // urlApiUserMgnt: this._vm.$VUE_APP_URL_API_USER_MGNT,
    // urlApiMainProcess: this._vm.$VUE_APP_URL_API_MAIN_PROCESS,
    // urlApiSystemConfig: this._vm.$VUE_APP_URL_API_SYSTEM_CONFIG,
    // urlApiGeneratePdf: this._vm.$VUE_APP_URL_API_GENERATE_PDF,
    // urlApiReserveNumber: this._vm.$VUE_APP_URL_API_RESERVE,
    userrole: null,
  },
  mutations: {
    TOGGLE_SNACKBAR_TOKEN(state, bl){
      state.snackbarToken = bl
    },
    SET_OUTBOUND_ADDRESS(state, value) {
      state.outboundADDRESS = value;
    },
    UPDATE_TOKEN(state, value) {
      state.userrole = value.role.toLowerCase();
    },
  },
  getters: {
    getUserrole(state) {
      return state.userrole;
    },
    getSnackbar(state){
      return state.snackbarToken;
    },
    getSnackbarMessage(state){
      return state.snackbarMessage;
    },
    getSnackbarTimeout(state){
      return state.snackbarTimeout;
    },
  },
  actions: {
    setSnackbarToken(context, bl) {
      context.commit("TOGGLE_SNACKBAR_TOKEN", bl);
    },
    updateToken(context, token) {
      context.commit("UPDATE_TOKEN", token);
    },
    getOutboundAddress(context) {
      console.log('_vm');
      console.log(this._vm.$VUE_APP_URL_API_RESERVE);
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          API_ACCESS_KEY: this.$VUE_APP_ACCESS_KEY_USER_MNGT,
        },
      };
      axios
        .get(
          this._vm.$VUE_APP_URL_API_SYSTEM_CONFIG +
            "SystemConfig/GetByKey/OUTBOUND_ADDRESS",config
        )
        .then((response) => {
          setTimeout(() => {
            context.commit("SET_OUTBOUND_ADDRESS", response.data.value);
          }, 500);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRefreshToken(context) {
      console.log('_vm');
     console.log(this._vm);
        return new Promise((resolve, reject) => {
          let config = {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: "Bearer " + localStorage.getItem("token"),
              API_ACCESS_KEY: this.$VUE_APP_ACCESS_KEY_USER_MNGT,
            },
          };
    
          let params = qs.stringify({
            grant_type: "refresh_token",
            client_id: "company-employee",
            client_secret: "codemazesecret",
            refresh_token: localStorage.refreshToken,
          });
          axios
            .post(
              this._vm.$VUE_APP_URL_API_AUTHEN + "connect/token",
              params,
              config
            )
            .then((response) => {
              console.log(response.data);
              var decoded = jwt_decode(response.data.access_token);

              //Get new token and new refresh token
              localStorage.token = response.data.access_token;
              localStorage.accessToken = response.data.access_token;
              localStorage.refreshToken = response.data.refresh_token;

              //Keep identity history
              var item = {
                AccessToken: response.data.access_token,
                RefreshToken: response.data.refresh_token,
                CreateDate: decoded.auth_time,
                ExpiredDate: decoded.exp,
              };

              var identityHistory = [];
              //console.log("identity add");
              if (localStorage.identityHistory) {
                identityHistory = JSON.parse(localStorage.identityHistory);
              }
              identityHistory.push(item);

              //console.log("identity convert to strng");
              localStorage.identityHistory = JSON.stringify(identityHistory);

              // self.description = "Refresh Token ";

              // return response data
              resolve(response);
            })
            .catch((error) => {
              context.dispatch("setSnackbarToken",true)
              localStorage.clear();
              //console.log("Error");
              //console.log(error.response);
              router.push("/");
              // return error
              reject(error);
            });
        });
    },
  },
  modules: {},
});
